// eslint-disable-next-line import/prefer-default-export
export function refresh(promise) {
  return promise.catch(() => {
    // asnyc chunk could not be loaded
    if (!window.location.href.match(/moduleError/)) {
      window.location.href = `${window.location.href}?moduleError=1`;
    }
  });
}
